/* eslint-disable import/order */
import React, { useState, useEffect } from 'react';
import './loader.sass';
import { isChineseDomain } from 'variables/is-chinese-domain';
import { getUrl } from 'variables/host';
import { withI18N } from '../../hoc-components';
import compose from 'utils/helper-functions/compose';
import Timer from '../timer';
import PaymentMethodSkeleton from '@pano-project/pages/processing-pages/current-method-page/payment-method-skeleton';
import { RecoverySettingsModel } from 'utils/models/RecoverySettings.Model.ts';
import { isPanoramicTheme } from '../../../@pano-project/variables/is-panoramic-2-0-theme';
import Spinner from '@pano-project/components/Spinner/Spinner';
import { shallowEqual, useSelector } from 'react-redux';
import { isDarkSystemAppearance } from '../../../@pano-project/variables/theme-mode';

const Loader = (props) => {
  const {
    fixed = false,
    index = false,
    text = false,
    showLoaderIcon = true,
    className = '',
    langBack,
    showTimer = false,
    isDynamicFields = false,
    skeletonLoader = false,
    smallLoader = false,
    initTheme: initThemeProp = false,
  } = props;
  const [delayLoaderText, setDelayLoaderText] = useState(false);
  const { layout, isDarkMode, cashierAppearanceMode } = useSelector(
    ({ initTheme }) => ({
      layout: initTheme?.theme_editor_settings?.customization_settings?.layout,
      isDarkMode: initTheme?.cashier_appearance_mode === 'dark-mode',
      cashierAppearanceMode: initTheme?.cashier_appearance_mode,
    }),
    shallowEqual,
  );
  const isAmountFirst = layout === 'amount-first';
  const effectiveDarkMode = isAmountFirst
    ? initThemeProp && initThemeProp.cashier_appearance_mode
      ? initThemeProp.cashier_appearance_mode === 'dark-mode'
      : cashierAppearanceMode
        ? isDarkMode
        : isDarkSystemAppearance
    : isDarkMode || (initThemeProp === false && isDarkSystemAppearance);
  const loaderLink = `${
    isChineseDomain
      ? 'https://alt-cdn.prx-pay.com/images/Cashier_cubes_preloader.gif'
      : getUrl('assetsLink')
  }`;
  const { ob_decline_recovery, ob_additional_fields_filled } =
    RecoverySettingsModel.getRecoverySettings();

  useEffect(() => {
    const timeId = setTimeout(() => {
      setDelayLoaderText(true);
    }, 15000);

    return () => {
      clearTimeout(timeId);
    };
  }, []);

  if (skeletonLoader && !isDynamicFields && !isAmountFirst) {
    return <PaymentMethodSkeleton />;
  }
  const spinnerSize = smallLoader ? 20 : isDynamicFields ? 30 : 48;
  return (
    <div
      className={`loader-container ${fixed ? 'fixed' : ''} ${index ? 'index' : ''} ${delayLoaderText ? 'loader-delay' : ''} ${ob_decline_recovery && ob_additional_fields_filled && !isDynamicFields ? 'non-transparent' : ''} ${isAmountFirst ? '_amount-first' : ''} ${isAmountFirst && (isDarkMode || effectiveDarkMode) ? '_dark' : ''} ${className ?? ''} ${smallLoader ? '_small-loader' : ''}`}
    >
      {isPanoramicTheme ? (
        <div className="loader-pano">
          <Spinner size={spinnerSize} />
        </div>
      ) : (
        <>
          {text && <div className={'loader-text'}>{text}</div>}
          {showLoaderIcon && (
            <div className="loader" style={{ backgroundImage: `url(${loaderLink})` }}></div>
          )}
          {delayLoaderText && !smallLoader && (
            <div className={'loader-delay-text'}>{langBack('delayLoaderText')}</div>
          )}
          {showTimer && <Timer />}
        </>
      )}
    </div>
  );
};

export default compose(withI18N)(Loader);
